"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PACKAGING_TYPE_ORDER = exports.PackagingType = void 0;
var PackagingType;
(function (PackagingType) {
    PackagingType["SHIPS_IN_OWN_CONTAINER"] = "SHIPS_IN_OWN_CONTAINER";
    PackagingType["POLY_BAG"] = "POLY_BAG";
    PackagingType["BUBBLE_MAILER"] = "BUBBLE_MAILER";
    PackagingType["BOX"] = "BOX";
})(PackagingType = exports.PackagingType || (exports.PackagingType = {}));
exports.PACKAGING_TYPE_ORDER = [
    PackagingType.SHIPS_IN_OWN_CONTAINER,
    PackagingType.POLY_BAG,
    PackagingType.BUBBLE_MAILER,
    PackagingType.BOX,
];
//# sourceMappingURL=PackagingType.js.map